import React from "react";
import { Card, Grid, Typography, Box, Divider } from "@mui/material";

function DoctorCard({ doctorData }) {
  const rawExperience =
    doctorData?.years_of_experience ??
    doctorData?.experience ??
    doctorData?.experience_years;
  const experienceNum =
    rawExperience !== undefined && rawExperience !== null && rawExperience !== ""
      ? Number(rawExperience)
      : NaN;
  const hideYearsOfExperienceRow =
    !Number.isNaN(experienceNum) && experienceNum === 0;

  return (
    <Card
      sx={{
        borderRadius: "10px",
        // background: "#E8E9F2",
        background: "#EBFAF9",
        // boxShadow: "0 2px 6px #21cdc0",
        width: { xs: "100%", md: "100%" },
        height: "auto",
        display: "flex",
        alignItems: "center",
        p: 2,
        // border: "1px solid #676565ff", 
          border: "1px solid #21cdc0",
      }}
    >
      {/* Left Section: Photo + Info */}
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          minWidth: "220px",
          pr: 2,
        }}
      >
        {/* Top Row -> Avatar + Name + Designation */}
        <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
          {/* Avatar */}
          {doctorData && doctorData.photo ? (
            <img
              src={`data:image/png;base64,${doctorData.photo}`}
              alt="Doctor"
              height="60"
              width="60"
              style={{ borderRadius: "50%", marginRight: "10px" }}
            />
          ) : (
            <img
              src="/img/doctor.png"
              alt="Default Doctor"
              height="60"
              width="60"
              style={{ borderRadius: "50%", marginRight: "10px" }}
            />
          )}

          {/* Name + Designation */}
          <Box>
            <Typography
              sx={{ fontSize: "14px", fontWeight: 600, textAlign: "left" }}
            >
              {doctorData ? `Dr. ${doctorData.name}` : "-"}
            </Typography>
            {/* <Typography
              sx={{
                fontSize: "12px",
                color: "#2196f3",
                fontWeight: 500,
                textAlign: "left",
              }}
            >
              Doctor
            </Typography> */}
          </Box>
        </Box>

      
      </Box>

      {/* Divider */}
      <Divider
        orientation="vertical"
        flexItem
        sx={{ mx: 2, borderColor: "#e0e0e0" }}
      />

      {/* Right Section: Details (2 columns) */}
      <Grid container spacing={2} sx={{ flex: 1 }}>
        {/* Left Column */}
        <Grid item xs={12} md={6}>
          <Grid container spacing={1}>
            {/* Email */}
            <Grid item xs={5}>
              <Typography sx={{ fontSize: "13px", fontWeight: 600 }}>
                Email:
              </Typography>
            </Grid>
            <Grid item xs={7}>
              <Typography sx={{ fontSize: "13px" }}>
                {doctorData ? doctorData.email : "-"}
              </Typography>
            </Grid>

            {/* Phone */}
            <Grid item xs={5}>
              <Typography sx={{ fontSize: "13px", fontWeight: 600 }}>
                Phone Number:
              </Typography>
            </Grid>
            <Grid item xs={7}>
              <Typography sx={{ fontSize: "13px" }}>
                {doctorData ? doctorData.phone_no : "-"}
              </Typography>
            </Grid>

            {/* Mobile */}
            <Grid item xs={5}>
              <Typography sx={{ fontSize: "13px", fontWeight: 600 }}>
                Mobile Number:
              </Typography>
            </Grid>
            <Grid item xs={7}>
              <Typography sx={{ fontSize: "13px" }}>
                {doctorData ? (doctorData.mobile || "-") : "-"}
              </Typography>
            </Grid>

            {/* Department */}
            <Grid item xs={5}>
              <Typography sx={{ fontSize: "13px", fontWeight: 600 }}>
                Department:
              </Typography>
            </Grid>
            <Grid item xs={7}>
              <Typography sx={{ fontSize: "13px" }}>
                {doctorData ? doctorData.department : "-"}
              </Typography>
            </Grid>

            {/* Specialization */}
            <Grid item xs={5}>
              <Typography sx={{ fontSize: "13px", fontWeight: 600 }}>
                Specialization:
              </Typography>
            </Grid>
            <Grid item xs={7}>
              <Typography sx={{ fontSize: "13px" }}>
                {doctorData ? (doctorData.specialization || "-") : "-"}
              </Typography>
            </Grid>
          </Grid>
        </Grid>

        {/* Right Column */}
        <Grid item xs={12} md={6}>
          <Grid container spacing={1}>
            {/* Qualifications */}
            <Grid item xs={5}>
              <Typography sx={{ fontSize: "13px", fontWeight: 600 }}>
                Qualifications:
              </Typography>
            </Grid>
            <Grid item xs={7}>
              <Typography sx={{ fontSize: "13px" }}>
                {doctorData ? doctorData.qualifications : "-"}
              </Typography>
            </Grid>

            {/* Gender */}
            <Grid item xs={5}>
              <Typography sx={{ fontSize: "13px", fontWeight: 600 }}>
                Gender:
              </Typography>
            </Grid>
            <Grid item xs={7}>
              <Typography sx={{ fontSize: "13px" }}>
                {doctorData ? doctorData.gender : "-"}
              </Typography>
            </Grid>

            {/* Languages Spoken */}
            <Grid item xs={5}>
              <Typography sx={{ fontSize: "13px", fontWeight: 600 }}>
                Languages Spoken:
              </Typography>
            </Grid>
            <Grid item xs={7}>
              <Typography sx={{ fontSize: "13px" }}>
                {doctorData
                  ? (Array.isArray(doctorData.languages_spoken)
                      ? doctorData.languages_spoken.join(", ")
                      : (doctorData.languages_spoken || doctorData.languages || doctorData.language_spoken || "-"))
                  : "-"}
              </Typography>
            </Grid>

            {/* Years of Experience — hidden when API returns 0 */}
            {!hideYearsOfExperienceRow && (
              <>
                <Grid item xs={5}>
                  <Typography sx={{ fontSize: "13px", fontWeight: 600 }}>
                    Years of Experience:
                  </Typography>
                </Grid>
                <Grid item xs={7}>
                  <Typography sx={{ fontSize: "13px" }}>
                    {doctorData ? rawExperience ?? "-" : "-"}
                  </Typography>
                </Grid>
              </>
            )}
          </Grid>
        </Grid>
      </Grid>
    </Card>
  );
}

export default DoctorCard;
